import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployment, getNonStipendiaryEmployment } from '../../../../global/ducks/benadmin-api';
import { TcsmStates } from '../../../../root/tcsm-model';
import { InstitutionState } from '../institutions/institution-model';
import { EmploymentState } from './employment-model';
import { dispatchSetEmployment, dispatchSetEmploymentFailed, dispatchSetNonStipendiaryEmployment } from './employment-slice';

export function useEmploymentInfo() {
    const dispatch = useDispatch();
    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);

    // values needed for API requests
    const employeeId = employmentState?.currentEmployee?.id;
    const employmentId = employmentState?.currentEmployee?.employment_id;
    const institutionClientNumber = institutionState?.institutionClientNumber;

    useEffect(() => {
        if (employeeId && institutionClientNumber && !employmentState?.employmentLoaded && !employmentState?.nonStipEmploymentLoaded) {
            if (employmentId) {
                dispatch(getEmployment(employeeId, employmentId, dispatchSetEmployment(dispatch), () => dispatchSetEmploymentFailed(dispatch)));
            }

            dispatch(getNonStipendiaryEmployment(employeeId, dispatchSetNonStipendiaryEmployment(dispatch, institutionClientNumber)));
        }
    }, [employeeId, employmentId, institutionClientNumber]);

    return institutionClientNumber && employeeId && (employmentState.employmentLoaded || employmentState.nonStipEmploymentLoaded);
}
